export const creationTypeOptions = [
  { text: 'Constant', value: 'CONSTANT' },
  { text: 'Random', value: 'RANDOM' },
] as const;

export const CreationTypeList = creationTypeOptions.map(
  (x) => x.value
);

export type CreationType =
  typeof creationTypeOptions[number]['value'];


export interface IGenerable {
  creationType?: CreationType;
  creationOptions?: {
    min: number;
    max: number;
  };
}
